import styled from 'styled-components'

import Card from '~/components/Card'

export const Container = styled(Card)`
	min-height: 82vh;
	margin: 40px 80px;

`
